import 'owl.carousel';

export function sliders()
{
		let sliders = $('.home-slider__slider-wrapper');

		sliders.each(function(){
				//Change the options here - you can use data-* tags to specify different values for different sliders
				let options = {
						items: 1,
						autoplay: true,
						animateIn: 'fadeIn',
						animateOut: 'fadeOut',
						mouseDrag: false,
						touchDrag: false,
						loop: true,
				};

				$(this).owlCarousel(options);
		}),

		sliders = $('.project-slider__slider');

		sliders.each(function(){
				//Change the options here - you can use data-* tags to specify different values for different sliders
				let options = {
						items: 1,
						loop: true,
						nav: true,
						smartSpeed: 1500,
				};

				$(this).owlCarousel(options);
		})
}



// WEBPACK FOOTER //
// ./scripts/modules/sliders.js